<template>
  <v-snackbar
    bottom
    right
    :value="updateExists"
    :timeout="-1"
    color="primary"
    :class="{ shake: shake }"
    class="update-snackbar"
  >
    <div class="update-content">
      <div class="text-content">
        <div class="title">Ny version tilgængelig</div>
        <div class="subtitle">
          <span
            >Der er kommet en opdatering med forbedringer og nye
            funktioner.</span
          ><br />
          <span>Opdater siden for at få den bedste oplevelse.</span>
        </div>
      </div>
      <v-btn
        outlined
        class="update-btn"
        @click="refreshApp"
        v-text="$t('general.update')"
      />
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: "NewUpdates",
  data() {
    return {
      // refresh variables
      refreshing: false,
      registration: null,
      updateExists: false,
      shake: false,
      interval: null,
    };
  },
  created() {
    // Listen for our custom event from the SW registration
    document.addEventListener("swUpdated", this.updateAvailable, {
      once: true,
    });

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      // Here the actual reload of the page occurs
      window.location.reload();
    });
  },

  methods: {
    // Store the SW registration so we can send it a message
    // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
      this.interval = setInterval(this.activeAnimation, 2000);
    },

    // Called when the user accepts the update
    refreshApp() {
      this.updateExists = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return;
      // send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },
    activeAnimation: function () {
      const self = this;
      self.shake = !self.shake;
    },
  },
};
</script>

<style>
.update-snackbar {
  min-width: 450px;
  min-height: 160px;
  font-size: 16px;
  padding: 32px;
  border-radius: 8px;
}

.update-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.text-content {
  flex: 1;
}

.update-snackbar .title {
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 8px;
  color: white;
}

.update-snackbar .subtitle {
  font-size: 16px;
  color: white;
  line-height: 1.5;
}

.update-btn {
  align-self: flex-start;
  min-width: 120px;
  height: 40px;
  font-size: 16px;
}
</style>
